import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'consultation':
        return 'MessageSquare';
      case 'profile':
        return 'User';
      case 'payment':
        return 'DollarSign';
      case 'review':
        return 'Star';
      default:
        return 'Bell';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'consultation':
        return 'text-primary bg-primary/10';
      case 'profile':
        return 'text-secondary bg-secondary/10';
      case 'payment':
        return 'text-success bg-success/10';
      case 'review':
        return 'text-warning bg-warning/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const formatRelativeTime = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffMinutes = Math.floor((now - activityTime) / (1000 * 60));
    
    if (diffMinutes < 1) return 'همین الان';
    if (diffMinutes < 60) return `${diffMinutes} دقیقه پیش`;
    
    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) return `${diffHours} ساعت پیش`;
    
    const diffDays = Math.floor(diffHours / 24);
    if (diffDays < 7) return `${diffDays} روز پیش`;
    
    return activityTime?.toLocaleDateString('fa-IR');
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-card-foreground">فعالیت‌های اخیر</h3>
        <button className="text-sm text-primary hover:text-primary/80 transition-colors">
          مشاهده همه
        </button>
      </div>
      <div className="space-y-4">
        {activities?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Activity" size={48} className="text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground">هیچ فعالیتی یافت نشد</p>
          </div>
        ) : (
          activities?.map((activity) => (
            <div key={activity?.id} className="flex items-start space-x-reverse space-x-3">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${getActivityColor(activity?.type)}`}>
                <Icon name={getActivityIcon(activity?.type)} size={16} />
              </div>
              
              <div className="flex-1 min-w-0">
                <p className="text-sm text-card-foreground mb-1">
                  {activity?.description}
                </p>
                <p className="text-xs text-muted-foreground">
                  {formatRelativeTime(activity?.timestamp)}
                </p>
              </div>
              
              {activity?.actionRequired && (
                <div className="w-2 h-2 bg-error rounded-full flex-shrink-0 mt-2"></div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;